import script from "./EditLinkModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditLinkModal.vue?vue&type=script&setup=true&lang=js"

import "./EditLinkModal.vue?vue&type=style&index=0&id=3401fadf&lang=scss"

export default script